export default "/images/date-input.svg?0b5b8dbe47aae58c166ee09c0e39887e";